import styled, { css } from "styled-components/macro";
import React from "react";


const Recommendation = styled.div`
  display: flex;
    flex-direction: row;
    padding-top: 14px;
    padding-left: 8px;
    align-items: center;
    justify-content: flex-start;
    gap: 4px;
`;

const Typography1 = styled.div`
  height: 20px;
  padding-left: 18px;
  top: 178px;
  font-family: 'Noto Sans';
  font-style: normal;
  font-size: 16px;
  line-height: 20px;
  color: #273139;
`;

const CloudResourcesType = styled.span`
font-style: normal;
font-weight: 600;
font-size: 14px;
line-height: 20px;
color: #273139;
`;

const Flex = styled.div`
  display: flex;
  flex-direction: row;
  
`;

const SpanWithMargin = styled.span`
  margin-right: 10px; // Change the value as per your need
`;

const CloudIcon = styled.img`
  width: 20px;
  height: 20px;
  object-fit: contain;
  display: inline-block;
  vertical-align: middle;
`;

const ReplicatedTag = styled.span`
  display: inline-block;
  margin-left: 8px;
  padding: 2px 8px;
  font-size: 11px;
  font-weight: 600;
  line-height: 16px;
  color: #0c5395;
  background: #e2eefb;
  border-radius: 10px;
  vertical-align: middle;
`;

const ResourcesWidget = ({
                             resourcedata,
                             replicationMode,
                       }: {
    resourcedata: CloudResourcesType;
    replicationMode?: 'separate' | 'replicated';
}) => {
    var cacheIcon = resourcedata.CacheIcon;
    var resourceType = resourcedata.ResourceType;
    var cacheName = resourcedata.CacheType;
    var registryIcon = resourcedata.RegistryIcon;
    var registryName = resourcedata.RegistryName
    return (
        <Flex>
            <Typography1>
                <Recommendation>
                    <CloudResourcesType>{resourceType}</CloudResourcesType>
                </Recommendation>
            </Typography1>
            <Typography1>
                <Recommendation>
                    <CloudIcon src={cacheIcon} alt={cacheName}/>
                    <SpanWithMargin>{cacheName}</SpanWithMargin>
                    <CloudIcon src={registryIcon} alt={registryName}/>
                    <span>{registryName}</span>
                    {replicationMode === 'replicated' && (
                        <ReplicatedTag title="Container registry is replicated from primary site">Replicated</ReplicatedTag>
                    )}
                </Recommendation>
            </Typography1>
        </Flex>
    );
};

export default ResourcesWidget;